export enum FilePreviewStatus {
    GENERATED = 'generated',
    PENDING = 'pending',
    FAILED = 'failed',
    NOT_SUPPORTED = 'not_supported',
    NOT_STARTED = 'not_started',
    SCANNING = 'scanning',
}